<template>
  <div style="text-align: right; margin: 20px 0px 0px 0px">
    <el-pagination
      :background="true"
      layout="prev, pager, next"
      :page-size="size"
      :total="total"
      @current-change="onPageChange"
      style="justify-content: flex-end"
    ></el-pagination>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  size: {
    type: Number,
    default: 10,
  },
  total: {
    type: Number,
    required: true,
  },
  onPageChange: {
    type: Function,
    required: true,
  },
});
</script>
